const extractMediaData = require("./extractMediaData");
const extractLinkData = require("./extractLinkData");
const extractButtonData = require("./extractButtonData");

module.exports = function transformCallToActionData(entity, sitemap) {
	const { id, type, attributes, relationships } = entity;

	const bg_image =
		relationships && relationships.field_background_image
			? extractMediaData(entity, "field_background_image")
			: null;

	const logo_image =
		relationships && relationships.field_logo
			? extractMediaData(node, "field_logo")
			: null;

	const buttons =
		attributes && Array.isArray(attributes.field_buttons)
			? attributes.field_buttons.map((a_btn) => extractLinkData(a_btn, sitemap))
			: [];

	if (attributes && attributes.field_to) {
		buttons.push(extractLinkData(attributes.field_to, sitemap));
	}

	const button_entities =
		relationships && relationships.field_buttons_entities
			? relationships.field_buttons_entities
			: null;

	if (button_entities && button_entities.data) {
		button_entities.data.forEach((btn) => {
			const btn_data = extractButtonData(btn, sitemap);
			if (btn_data) {
				buttons.push(btn_data);
			}
		});
	}

	let txt =
		attributes && attributes.body
			? attributes.body.transformed
				? attributes.body.transformed
				: attributes.body.value
			: null;

	let align = attributes && attributes.field_align ? attributes.field_align : "left";
	let data = {
		id,
		type,
		align,
		title: entity.attributes.title,
		subtitle: attributes && attributes.field_subtitle ? attributes.field_subtitle : null,
		body: txt,
		backgroundColor:
			attributes && attributes.field_background_color
				? attributes.field_background_color
				: null,
		backgroundImage: bg_image ? bg_image.src : null,
		logo: logo_image ? logo_image.src : null,
		headingType:
			attributes && attributes.field_cta_heading_type
				? attributes.field_cta_heading_type
				: "h3",
		gradient: attributes && attributes.field_gradient ? true : false,
		textShadow: attributes && attributes.field_gradient ? true : false,
		buttons,
		search: attributes && attributes.field_display_search_form === true,
		newsletter: attributes && attributes.field_display_newsletter_form === true,
		searchPlaceholder:
			attributes && attributes.field_search_placeholder
				? attributes.field_search_placeholder
				: "Search this website...",
		newsletterPlaceholder:
			attributes && attributes.field_newsletter_placeholder
				? attributes.field_newsletter_placeholder
				: "Enter your email...",
		layout:
			attributes && attributes.field_cta_layout ? attributes.field_cta_layout : null,
		searchVariant:
			attributes && attributes.field_cta_search_vari
				? attributes.field_cta_search_vari
				: "filled",
	};
	return data;
};
